import { ELanguage } from '@/consts/language';

export function getI18nCurrentLocale() {
  return window.sessionStorage.getItem('__com_sankuai_oa_it_ssoweb__.i18nLocale');
}

/**
 * @description: sso语言参数转换为yoda的语言参数
 * @param {*} lang
 * @return {*}
 */
export function lang2yodaLang(lang) {
  // yoda国内版本目前仅支持中文 英文 日文
  switch (lang) {
    case ELanguage.en:
    case ELanguage.ar:
    case ELanguage['pt-BR']:
      return 'en';
    case ELanguage.zh:
    case ELanguage['zh-HK']:
    default:
      return 'zh-CN';
  }
}

/**
 * @description: 将语言转换成标准语言格式
 * @param {*} lang
 * @return {*}
 */
export function transLang(lang) {
  if (/^zh-(HK|TW)/i.test(lang)) {
    return ELanguage['zh-HK'];
  }
  if (/^(en|es)-?/.test(lang)) {
    return ELanguage.en;
  }
  // 阿拉伯语
  if (/^(ar)-?/.test(lang)) {
    return ELanguage.ar;
  }
  // 葡萄牙语
  if (/^(pt)-?/.test(lang)) {
    return ELanguage['pt-BR'];
  }
  return ELanguage.zh;
}


const logoZh = 'https://s3plus.meituan.net/sso-service/static/images/login/daxiang/daxiangLogoZh.png';
const daxiangListZh = 'https://s3plus.meituan.net/sso-service/static/images/login/daxiang/daxiangListZh.jpg';

const logo = 'https://s3plus.meituan.net/sso-service/static/images/login/daxiang/daxiangLogo.png';
const daxiangList = 'https://s3plus.meituan.net/sso-service/static/images/login/daxiang/daxiangList.png';

export function getDaXiangLogo(lang: ELanguage) {
  switch (lang) {
    case ELanguage.zh:
      return logoZh;
    default:
      return logo;
  }
}

export function getDaXiangList(lang: ELanguage) {
  switch (lang) {
    case ELanguage.zh:
      return daxiangListZh;
    default:
      return daxiangList;
  }
}

const zhLogo = 'https://s3plus.meituan.net/v1/mss_e7b95138dc0d4c29858d76b37e6ebef7/sso-service/static/images/new_mt_yellow_logo.png';
const enLogo = 'https://s3plus.meituan.net/sso-service/static/images/login/default/mt_logo_en.png';

export function getMeituanLogo(lang?: ELanguage) {
  const locale = lang || getI18nCurrentLocale();
  switch (locale) {
    case ELanguage.zh:
      return zhLogo;
    default:
      return enLogo;
  }
}

/**
 * @description: 获取默认区号
 * @param {ELanguage} locale
 * @return {string}
 */
export function getDefaultInterCode(locale) {
  switch (locale) {
    case ELanguage.en:
      return 'China +86';
    case ELanguage['zh-HK']:
      return '中國 +86';
    case ELanguage['pt-BR']:
      return 'China +86';
    case ELanguage.ar:
      return '86+ الصين';
    default:
      return '中国 +86';
  }
}
